import { Button, Badge, Switch } from 'antd';
import { MessageOutlined, VideoCameraOutlined, BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useNodeInfo } from '../../hooks/use_node_info';
import './EntityComms.css';

function EntityComms({ entityId, entity, notifEnabled, onToggleNotif, style, messagesPath }) {
    const navigate = useNavigate();
    const { featureHangouts, featureNotifications } = useNodeInfo();
    const resolvedMessagesPath = messagesPath ?? `/messages/${entityId}`;
    const hideMessages = !!messagesPath;

    return (
        <div className="entity-comms" style={style}>
            <div className="entity-comms-row">
                {/* Messages */}
                {!hideMessages && (
                    <div className="entity-comms-cell">
                        <Button size="small" icon={<MessageOutlined />} onClick={() => navigate(resolvedMessagesPath)}>Messages</Button>
                    </div>
                )}

                {/* Hangout */}
                {featureHangouts && (
                    <div className="entity-comms-cell">
                        <Badge dot={entity.hangout_active} color="green">
                            <Button
                                size="small"
                                icon={<VideoCameraOutlined />}
                                type={entity.hangout_active ? 'primary' : 'default'}
                                onClick={() => window.open(`/entity/${entityId}/hangout`, '_blank', 'noopener,noreferrer')}
                            >
                                {entity.hangout_active ? `${entity.hangout_participant_count} in room` : 'Call'}
                            </Button>
                        </Badge>
                    </div>
                )}

                {/* Notifications — hidden entirely on a node with the feature off,
                    where the preference routes behind this switch aren't mounted. */}
                {featureNotifications && (
                    <div className="entity-comms-cell">
                        <BellOutlined
                            className="entity-comms-icon"
                            style={{ opacity: notifEnabled ? 1 : 0.35 }}
                        />
                        <Switch size="small" checked={notifEnabled} onChange={onToggleNotif} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default EntityComms;
